// Vendor Libs
import React from 'react';
import PropTypes from 'prop-types';
import {startCase} from 'lodash';
import classnames from 'classnames';

// Components
import Button from '../core/button';
import Form from '../core/form';
import Input from '../core/input';
import SubmitButton from '../core/submit-button';

// Styles
import './providers-form.scss';

function ProvidersForm({className, editing, formName, onReset}) {
    const getFieldProps = (fieldName) => ({
        className: 'providers-form--field',
        label: startCase(fieldName),
        name: fieldName,
        validate: ['required'],
    });

    const handleCancelClick = (event) => {
        event && event.preventDefault && event.preventDefault();

        onReset();
    };

    const getFormProps = () => ({
        className: classnames('providers-form', className),
        fixedPositionedResponse: true,
        name: formName,
        resetOnSubmit: !editing,
        submitData: true,
    });

    return (
        <Form {...getFormProps()}>
            <Input {...getFieldProps('name')} validate={['required']} />
            <SubmitButton label="Save" />
            <Button className="providers-form--cancel-button" onClick={handleCancelClick}>
                Cancel
            </Button>
        </Form>
    );
}

ProvidersForm.propTypes = {
    className: PropTypes.string,
    editing: PropTypes.bool,
    formName: PropTypes.string,
    onReset: PropTypes.func,
};

export default ProvidersForm;
